const MODULE_ID = 'media';
export default MODULE_ID;
